module.exports = __webpack_public_path__ + "static/media/m_faceshape_square_vector.9202fa37.svg";